import { render, staticRenderFns } from "./CmmTmField.vue?vue&type=template&id=1991dfc5&"
import script from "./CmmTmField.vue?vue&type=script&lang=js&"
export * from "./CmmTmField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports